import type { ReactNode } from 'react';
import { Spinner, ErrorBox, EmptyBox } from './ui.js';

/**
 * 조회 한 건의 네 가지 상태를 한 곳에서 처리한다.
 *
 * 랜덤박스 네 화면이 모두 아래 사다리를 손으로 다시 적고 있었다.
 *
 *   isPending ? <Spinner/>
 *   : isError ? <ErrorBox error={...} onRetry={...}/>
 *   : data.items.length === 0 ? <EmptyBox/>
 *   : <표>
 *
 * 네 벌이 조금씩 달랐다 - 어떤 화면은 `onRetry` 를 빠뜨렸고, 어떤 화면은 빈
 * 데이터 문구가 기본값이었다. 사다리를 여기 하나로 모으면 화면마다 다르게
 * 새는 일이 없다.
 *
 * `empty` 는 **불리언으로 받는다.** 조회 결과의 모양(`items` 배열인지, 단건인지)
 * 은 화면마다 달라서, 여기서 판단하려 하면 도리어 타입이 복잡해진다.
 */
export function QueryState({
  query,
  empty,
  emptyMessage,
  children,
}: {
  query: {
    isPending: boolean;
    isError: boolean;
    error: unknown;
    refetch: () => unknown;
  };
  /** 조회는 성공했지만 보여줄 것이 없는가. */
  empty?: boolean;
  emptyMessage?: ReactNode;
  children: ReactNode;
}) {
  if (query.isPending) return <Spinner />;
  if (query.isError) return <ErrorBox error={query.error} onRetry={() => void query.refetch()} />;
  if (empty) return <EmptyBox>{emptyMessage}</EmptyBox>;
  return <>{children}</>;
}
